var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form-item',{staticClass:"file-box",attrs:{"label":_vm.data.fieldname}},[_c('a-upload',{directives:[{name:"decorator",rawName:"v-decorator",value:([
      `${_vm.data.fieldkey}`,
      {
        rules: [{
          validator: _vm.validateFile,
          message: _vm.uploadNeed
        }],
        initialValue: _vm.fileList
      },
    ]),expression:"[\n      `${data.fieldkey}`,\n      {\n        rules: [{\n          validator: validateFile,\n          message: uploadNeed\n        }],\n        initialValue: fileList\n      },\n    ]"}],attrs:{"action":_vm.action,"multiple":true,"headers":{'X-Requested-With': null},"accept":_vm.accept,"data":_vm.params,"file-list":_vm.fileList,"before-upload":_vm.beforeUpload,"remove":_vm.handleRemove},on:{"change":_vm.handleChange,"preview":_vm.onPreview}},[_c('a-button',[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(_vm._s(_vm.data.labelname || _vm.$t('message["986"]'))+"\n    ")],1),(!_vm.data.hideLimitText)?_c('span',{staticClass:"fs-gray"},[_vm._v(_vm._s(_vm.$t('message["1591"]')))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }